<template>
  <div>
    <button @click="downloadBackup">Download Backup</button>

    <div v-if="downloadProgress > 0 && downloadProgress < 100">
      Download Progress: {{ downloadProgress }}%
    </div>

    <input type="file" @change="onFileSelected" />
    <button @click="uploadBackup">Upload Backup</button>

    <p v-if="message" style="color:green">{{ message }}</p>
    <p v-if="error" style="color:red">{{ error }}</p>
  </div>
</template>

<script>
import backupApi from "@/api/backupApi";

export default {
  data() {
    return {
      file: null,
      message: "",
      error: "",
      downloadProgress: 0
    };
  },
  methods: {
    async downloadBackup() {
      try {
        this.downloadProgress = 0;
        const response = await backupApi.exportBackup({
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.downloadProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          }
        });

        // Convert the response data to a Blob and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = "data-backup.zip";
        a.click();
        window.URL.revokeObjectURL(url);

        this.message = "Backup downloaded successfully!";
        this.error = "";
        this.downloadProgress = 0;
      } catch (err) {
        this.error = err.response?.data || err.message;
        this.message = "";
        this.downloadProgress = 0;
      }
    },

    async uploadBackup() {
      if (!this.file) return;
      try {
        const response = await backupApi.importBackup(this.file);
        this.message = response.data || "Backup imported successfully!";
        this.error = "";
      } catch (err) {
        this.error = err.response?.data || err.message;
        this.message = "";
      }
    },

    onFileSelected(e) {
      this.file = e.target.files[0];
    }
  }
};
</script>
